import type { ComponentPropsWithoutRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from './Button';

export function ButtonCancel(props: ComponentPropsWithoutRef<typeof Button>) {
	const { t } = useTranslation('common');

	return (
		<Button color="primary" {...props} data-testid="button-cancel">
			{props.children || t('buttons.cancel')}
		</Button>
	);
}
